import { render, staticRenderFns } from "./ChatsRequestModal.vue?vue&type=template&id=0d49a949&scoped=true&"
import script from "./ChatsRequestModal.vue?vue&type=script&lang=js&"
export * from "./ChatsRequestModal.vue?vue&type=script&lang=js&"
import style0 from "./ChatsRequestModal.vue?vue&type=style&index=0&id=0d49a949&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d49a949",
  null
  
)

export default component.exports